/* ----------------------------------------------------------------------------
   DELIVERY ESTIMATOR — STATE PLACEHOLDER  (Plush + Oak)
   ----------------------------------------------------------------------------
   sections/po-configurator.liquid renders the delivery estimator's state <select>
   with no placeholder and no option marked selected, so the browser falls through
   to the first one alphabetically: Alabama. It reads as an answered field, so a
   shopper fills in only the ZIP — the box that is visibly empty — and clicks
   Check delivery cost. A state that does not match the ZIP returns:

     "No rate found for that code. Contact us for a custom quote."

   on a bed that actually ships for a flat $349. That message tells a ready buyer
   we cannot deliver to them.

   Measured on the live site, 2026-09-15:
     Alabama    + 90012  ->  "No rate found for that code."
     California + 90012  ->  "Unlimited Furniture Delivery (USA) — $349"
     Alabama    + 35004  ->  "Unlimited Furniture Delivery (USA) — $349"

   The estimator and its rate lookup are correct. Only the default is wrong, so
   this prepends a disabled placeholder and forces the state to be chosen.

   Stand-in for the proper fix, which is a placeholder option in the section's own
   markup. po-configurator.liquid is ~86KB — too large to reproduce byte-exactly
   through the Admin API, which is the rule for editing any theme file here. Fold
   it in whenever that file is next edited with a real dev workflow, and delete
   this.
   ---------------------------------------------------------------------------- */
(function () {
  if (window.__poEstimateState) return;
  window.__poEstimateState = true;

  var LABEL = 'Select state';
  var PROMPT = 'Choose your state, then check the delivery cost.';
  var timer;

  function fix(select) {
    if (!select || select.__poFixed) return;

    var first = select.options[0];
    if (!first) return;

    /* Already has a placeholder — nothing to do. */
    if (first.value === '') { select.__poFixed = true; return; }

    /* If a real state is genuinely pre-selected — a returning customer, or a
       value restored from a saved address — leave the shopper's answer alone. */
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].defaultSelected) { select.__poFixed = true; return; }
    }

    select.__poFixed = true;

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = LABEL;
    placeholder.disabled = true;
    placeholder.selected = true;

    select.insertBefore(placeholder, first);
    select.selectedIndex = 0;
  }

  function scan() {
    var list = document.querySelectorAll('select[data-poc-est-province]');
    for (var i = 0; i < list.length; i++) fix(list[i]);
  }

  function scanSoon() {
    clearTimeout(timer);
    timer = setTimeout(scan, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* The configurator rebuilds parts of the summary as the build changes, so the
     select can be replaced after first paint. Debounced — fix() is idempotent. */
  if (window.MutationObserver) {
    new MutationObserver(scanSoon).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', scan);

  /* The placeholder alone is not enough. With no state chosen the lookup still
     runs, still fails, and still reports "No rate found for that code" — the same
     false negative, just one step later. Capture the click before the section's
     own handler and ask for the state instead. Once a state is chosen this does
     nothing and the estimator behaves exactly as before. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-poc-est-go]') : null;
    if (!button) return;

    var scope = button.closest('.poc-estimate') || document;
    var select = scope.querySelector('select[data-poc-est-province]');
    if (!select || select.value !== '') return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var output = scope.querySelector('[data-poc-est-result]');
    if (output) {
      output.textContent = PROMPT;
      output.hidden = false;
    }

    try { select.focus(); } catch (e) {}
  }, true);
})();